import React from 'react'

const PoseCard = (props) => {

  return (
      <div className="col s12 m6 l4">
        <div className="card small yoga-pose-card">
          <div className="card-image">
            <img src={props.pose.imageUri} alt="{props.pose.name}"></img>
          </div>
          <div className="card-content">
            <span className="card-title">{props.pose.name}</span>
            <i className="material-icons teal-text right">favorite</i>

            <p>{props.pose.level}</p>
          </div>
        </div>
      </div>
  )
}

export default PoseCard